import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import type { FC } from 'react';
import {
  LinkWrapper,
  OrderLineItemCost,
  OrderLineItemImage,
  OrderLineItemQuantity,
  OrderLineItemTitle,
  OrderLineItemTitleWrapper,
  OrderLineItemWrapper,
} from './OrderLineItem.style';

interface OrderLineItemProps {
  imageUrl?: string;
  productUrl?: string;
  title?: string;
  quantity?: string;
  cost?: string;
}

export const OrderLineItem: FC<OrderLineItemProps> = ({ imageUrl, productUrl, title, quantity, cost }) => {
  const { t } = useGlobalState();
  const qty = quantity ? `${t(MasterTranslation.Qty)}: ${quantity}` : '';

  const renderImage = () => {
    if (!imageUrl) return null;
    return <OrderLineItemImage src={imageUrl} alt={title || 'product-img'} />;
  };

  return (
    <>
      <OrderLineItemWrapper hasImage={!!imageUrl}>
        {renderImage()}
        <OrderLineItemTitleWrapper>
          <LinkWrapper href={productUrl}>
            <OrderLineItemTitle>{title}</OrderLineItemTitle>
          </LinkWrapper>
          <OrderLineItemQuantity>{qty}</OrderLineItemQuantity>
        </OrderLineItemTitleWrapper>
      </OrderLineItemWrapper>
      <OrderLineItemCost>{cost}</OrderLineItemCost>
    </>
  );
};
